module.exports = __webpack_public_path__ + "static/img/logo-symbol.5dbae21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-symbol.jpg
// module id = 366
// module chunks = 2